import { render, staticRenderFns } from "./userSettings.vue?vue&type=template&id=0457c1d0&lang=html&"
import script from "./userSettings.vue?vue&type=script&lang=ts&"
export * from "./userSettings.vue?vue&type=script&lang=ts&"
import style0 from "./userSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports